module.exports = __webpack_public_path__ + "img/68.5.COD.47bd0a1c.png";